__webpack_require__.p = "https://LaborManagementMFE-dev.shipbob.dev/";